import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import "../App.css"

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { name: "Overview", path: "/dashboard" },
    { name: "Bot Settings", path: "/settings" },
    // { name: "KnowledgeBase", path: "/kowledge" },
    { name: "Products & Services", path: "/products" },
    { name: "CRM", path: "/CRM" },
    { name: "Block Numbers", path: "/numbers" },
    { name: "PlayGround", path: "/chatbot" },
    { name: "WhatsApp Link", path: "/whatsapp" },
    { name: "Packages & Billing", path: "/plans" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.clear();
    window.dispatchEvent(new Event("storage"));
    navigate("/login", { replace: true });
  };

  return (
    <>
      {/* زر القائمة في الموبايل */}
      <div className="md:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setOpen(!open)}
          className="p-2 bg-primary text-cream rounded-md shadow-md focus:outline-none"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* الشريط الجانبي */}
      <div
        className={`fixed top-0 left-0 h-screen w-64 bg-primary text-cream p-6 flex flex-col justify-between transform transition-transform duration-300 z-40
        ${open ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        {/* المحتوى القابل للتمرير */}
        <div className="flex flex-col justify-between h-full overflow-y-auto scroll-smooth">
          {/* الشعار */}
          <div className="flex items-center justify-center mb-4">
            <img
              src="/zuccesslogo.png"
              alt="Zuccess Logo"
              className="w-28 h-28 object-contain drop-shadow-lg"
            />
          </div>

          {/* الروابط */}
          <nav className="flex flex-col gap-3 mb-4">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setOpen(false)}
                className={`px-3 py-2 rounded-lg transition-all ${
                  location.pathname === link.path
                    ? "bg-accent text-white shadow-lg"
                    : "text-cream/80 hover:bg-accent/70 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* زر تسجيل الخروج */}
          <div className="mt-auto">
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 bg-accent/80 hover:bg-accent text-white py-2 rounded-lg transition-all font-semibold shadow-md"
            >
              <LogOut size={18} />
              Logout
            </button>

            <div className="text-xs text-cream/60 text-center mt-4">
              © {new Date().getFullYear()} Zuccess
            </div>
          </div>
        </div>
      </div>

      {/* خلفية عند فتح القائمة في الموبايل */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
          onClick={() => setOpen(false)}
        ></div>
      )}
    </>
  );
}
